/**
 * *************************************************************************************
 * * ⚠️ The endpoint code is being migrated to @library/endpoint.                       *
 * * As a short-term measure the 'monolith' code will re-export library code           *
 * *************************************************************************************
 */
import { endpoint } from '@library/endpoint'

export default endpoint
